import React from "react";
import { useForm } from "react-hook-form";
import "./RoomingForm.css";

const DiabetesPatientRoomingForm = () => {
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = (data) => {
    console.log("Rooming Data Submitted:", data);
    alert("Form submitted successfully!");
    reset();
  };

  return (
    <div className="form-container">
      <h1 className="form-title">Diabetes Patient Rooming Form</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Patient Identification */}
        <fieldset className="form-fieldset">
          <legend className="form-legend">Patient Identification</legend>
          <label className="form-label">
            Full Name:
            <input
              type="text"
              {...register("fullName")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            Date of Birth:
            <input
              type="date"
              {...register("dateOfBirth")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            Purpose of Visit:
            <textarea
              {...register("visitPurpose")}
              className="form-textarea"
            />
          </label>
        </fieldset>

        {/* Vital Signs */}
        <fieldset className="form-fieldset">
          <legend className="form-legend">Vital Signs</legend>
          <label className="form-label">
            Blood Pressure:
            <input
              type="text"
              {...register("bloodPressure")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            Heart Rate:
            <input
              type="number"
              {...register("heartRate")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            Respiratory Rate:
            <input
              type="number"
              {...register("respiratoryRate")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            Temperature:
            <input
              type="number"
              {...register("temperature")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            Weight (kg):
            <input
              type="number"
              {...register("weight")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            Height (cm):
            <input
              type="number"
              {...register("height")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            BMI:
            <input
              type="number"
              {...register("bmi")}
              className="form-input"
            />
          </label>
        </fieldset>

        {/* Diabetes-Specific Assessments */}
        <fieldset className="form-fieldset">
          <legend className="form-legend">Diabetes-Specific Assessments</legend>
          <label className="form-label">
            Blood Glucose Level (if applicable):
            <input
              type="number"
              {...register("bloodGlucoseLevel")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            CGM Data Downloaded:
            <select {...register("cgmDataDownloaded")} className="form-select">
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </label>
          <label className="form-label">
            Foot Inspection:
            <textarea
              {...register("footInspection")}
              className="form-textarea"
            />
          </label>
        </fieldset>

        {/* Medication Reconciliation */}
        <fieldset className="form-fieldset">
          <legend className="form-legend">Medication Reconciliation</legend>
          <label className="form-label">
            Current Medications (name, dose, frequency):
            <textarea
              {...register("currentMedications")}
              className="form-textarea"
            />
          </label>
          <label className="form-label">
            Adherence Issues:
            <textarea
              {...register("adherenceIssues")}
              className="form-textarea"
            />
          </label>
          <label className="form-label">
            Allergies:
            <textarea
              {...register("allergies")}
              className="form-textarea"
            />
          </label>
        </fieldset>

        {/* Review of Systems (ROS) */}
        <fieldset className="form-fieldset">
          <legend className="form-legend">Review of Systems (ROS)</legend>
          <label className="form-label">
            General (e.g., fatigue, weight changes):
            <textarea
              {...register("generalSymptoms")}
              className="form-textarea"
            />
          </label>
          <label className="form-label">
            Endocrine (e.g., thirst, frequent urination):
            <textarea
              {...register("endocrineSymptoms")}
              className="form-textarea"
            />
          </label>
          <label className="form-label">
            Neurological (e.g., numbness, tingling):
            <textarea
              {...register("neurologicalSymptoms")}
              className="form-textarea"
            />
          </label>
          <label className="form-label">
            Cardiovascular (e.g., chest pain, palpitations):
            <textarea
              {...register("cardiovascularSymptoms")}
              className="form-textarea"
            />
          </label>
        </fieldset>

        {/* Preventive Care */}
        <fieldset className="form-fieldset">
          <legend className="form-legend">Preventive Care</legend>
          <label className="form-label">
            Vaccination Status (e.g., flu, pneumococcal):
            <textarea
              {...register("vaccinationStatus")}
              className="form-textarea"
            />
          </label>
          <label className="form-label">
            Last Eye Exam Date:
            <input
              type="date"
              {...register("lastEyeExamDate")}
              className="form-input"
            />
          </label>
          <label className="form-label">
            Last Podiatry Visit Date:
            <input
              type="date"
              {...register("lastPodiatryVisitDate")}
              className="form-input"
            />
          </label>
        </fieldset>

        {/* Submit Button */}
        <button
          type="submit"
          className="form-submit-button"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default DiabetesPatientRoomingForm;
